import React from "react";
import { Card } from "./TvBits";

const CALL = { buy: "#10B981", sell: "#EF4444", hold: "#F59E0B", watch: "#38BDF8" };

const Picks = ({ rows }) => (
  <div className="space-y-2">
    {rows.slice(0, 6).map((p, i) => (
      <div key={i} className="flex items-center gap-4 text-2xl">
        <b className="font-mono text-cyan-50 w-24 shrink-0">{p.ticker}</b>
        <span className="nx-orbitron text-sm font-black tracking-widest px-3 py-1 rounded-md w-20 text-center text-[#030712]" style={{ background: CALL[p.call] || "#94A3B8" }}>{(p.call || "").toUpperCase()}</span>
        <span className="text-xl text-cyan-100/80 truncate">{p.reason}</span>
      </div>
    ))}
  </div>
);

export const TvMadMoney = ({ d }) => {
  const mm = d.madmoney;
  if (!mm) return null;
  const s = mm.summary;
  return (
    <div className="grid grid-cols-5 gap-5 h-full" data-testid="tv-scene-madmoney">
      <Card title={`MAD MONEY · ${s.date || ""}`} accent="#F59E0B" code="CRAMER" className="col-span-3" testid="tv-mm-main">
        <p className="text-[clamp(1.25rem,2.2vw,2.25rem)] font-black text-white leading-tight line-clamp-3">{s.headline}</p>
        <p className="text-2xl text-cyan-100/80 mt-3 mb-5 leading-snug">{s.market_view}</p>
        <Picks rows={[...(s.picks || []), ...(s.lightning_round || [])]} />
      </Card>
      <div className="col-span-2 flex flex-col gap-5 min-h-0">
        <a href={mm.url} target="_blank" rel="noreferrer" className="relative rounded-3xl overflow-hidden shrink-0 border border-amber-300/30" data-testid="tv-mm-video">
          <img src={mm.thumbnail} alt="" className="w-full aspect-video object-cover" />
          <span className="absolute bottom-3 left-3 nx-mono text-sm bg-[#030712]/80 text-amber-200 px-3 py-1 rounded-md">▶ WATCH ON YOUTUBE</span>
        </a>
        <Card title="TAKEAWAYS" accent="#F59E0B" code={`${(s.lightning_round || []).length} LIGHTNING`} className="flex-1" testid="tv-mm-takeaways">
          <div className="space-y-3">{(s.takeaways || []).slice(0, 5).map((t, i) => <p key={i} className="text-xl text-cyan-50 leading-snug border-l-4 border-amber-400/60 pl-3">{t}</p>)}</div>
        </Card>
      </div>
    </div>
  );
};
